<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="indent">
          <strong>
            <a
              :class="{'prepared': (item.prepared || item.maximum) }"
              @click="showViewModal = true"
              v-if="item.description"
            >{{name}}</a>
            <span v-else>{{name}}</span>
            <pf-actions :item="item.actions"></pf-actions>
          </strong>
          <strong v-if="item.maximum" class="subheader">({{item.current}}/{{item.maximum}})</strong>

          <span style="float: right" v-if="item.maximum">
            <span class="cboxes" v-for="n in item.maximum" :key="n">
              <i
                v-if="cboxArray.includes(n)"
                class="fa fa-fw fa-check-square"
                aria-hidden="true"
                @click="upDown(-1)"
              ></i>
              <i v-else class="fa fa-fw fa-square-o c5" aria-hidden="true" @click="upDown(1)"></i>
            </span>
          </span>

          <br v-if="item.maximum">

          <strong v-if="item.detail">({{ item.detail }})</strong>
          <strong v-if="item.school" class="subheader">[{{item.school}}]</strong>
          <span class="item-description" v-if="item.summary">- {{ item.summary }}</span>
        </div>
      </div>

      <div class="col-flex" v-if="canEdit">
        <a :id="`${section}-${item._id}`" @click="$emit('setId')" class="cogs125 modal-toggle">
          <i class="fa fa-cog"></i>
        </a>
      </div>
    </div>

    <ez-modal v-if="showViewModal" @close="showViewModal = false" size="m-medium">
      <display :item="item" :ruleset="ruleset"></display>
    </ez-modal>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import Display from "./_Display.vue";
import modal from "@/mixins/vue-ez-modal";
import PfActions from "@/components/shared/_PfActions.vue";

export default {
  name: "sheet-spells-spell",
  mixins: [modal],
  components: {
    Display,
    PfActions,
  },
  props: ["section", "item", "ruleset"],
  data() {
    return {
      showViewModal: false,
    };
  },
  watch: {
    item: "updateFromRef",
  },
  computed: {
    ...mapGetters({ canEdit: "characters/canEdit" }),
    name() {
      let name = ["Savage Worlds"].includes(this.item.ruleset)
        ? "Power"
        : "Spell";
      return this.item.name || name;
    },
    cboxArray() {
      let arr = [];
      if (this.item.current && this.item.current > 0) {
        for (let i = 0; i < this.item.current; i++) {
          arr.push(i + 1);
        }
      }
      return arr;
    },
  },
  methods: {
    ...mapActions("characters", ["autoSave"]),
    updateFromRef() {
      if (this.item._ref) {
        this.$rpgv.updateFromRef(this.item);
      }
    },
    upDown(n) {
      if (this.canEdit) {
        this.item.current += n;
        this.autoSave();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/_global";

.cboxes {
  line-height: 1;
  font-size: 1.1em;
  cursor: pointer;
}

a {
  color: $gray-500 !important;
  &:hover {
    color: $gray-600 !important;
  }
}
</style>
